<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between">
        <v-col cols="12">
          <h1>Конструктор пиццы</h1>
        </v-col>
      </v-row>
      <v-tabs v-model="tab">
        <v-tab>Блюда</v-tab>
        <v-tab>Ингредиенты</v-tab>
        <v-tab>Модификаторы</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col cols="12" sm="3" class="">
              <template v-if="selected.length > 0">
              <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
              <v-menu offset-y left :disabled="selected.length === 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined
                         :disabled="selected.length === 0"
                         class="pl-0 pr-0"
                         min-width="36"
                         v-bind="attrs"
                         v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="submitDialog = true; submitItem = null">
                    <v-list-item-title>Удалить</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                      v-model="constructorEnabled"
                      hide-details
                      :label="constructorEnabled ? 'Выключить конструктор' : 'Включить конструктор'"
              ></v-switch>
            </v-col>
            <v-col class="text-right" cols="12" sm="3">
              <v-dialog v-model="dialog" max-width="608">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                          v-bind="attrs"
                          v-on="on"
                  >
                    Добавить
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Добавить блюда</span>
                  </v-card-title>
                  <v-card-text>
                    <ul>
                      <li v-for="pizza in pizzas" :class="{selected: pizza.selected}" v-if="!isExist(pizza)">
                        <v-simple-checkbox
                                v-model="pizza.selected"
                        >
                        </v-simple-checkbox>
                        <div class="name">{{ pizza.name }}</div>
                      </li>
                    </ul>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn block @click="addProductsToConstructor(); dialog = false">Добавить</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          <v-data-table
                  no-data-text="Нет блюд"
                  no-results-text="По заданному запросу ничего не найдено"
                  v-model="selected"
                  :headers="headers"
                  :header-props="{sortIcon: 'icon-custom-arrow'}"
                  :items="products"
                  :options.sync="options"
                  :fixed-header="true"
                  height="70vh"
                  :footer-props="footerProps"
                  :item-class="getItemClass"
                  :loading="loading"
                  :items-per-page="-1"
                  loading-text="Загрузка блюд... Подождите пожалуйста"
                  show-select
          >
            <template v-slot:item.price="{ item, index }">
              {{ item.price }} UAH
            </template>
            <template v-slot:item.tag="{ item, index }">
              <span v-for="tag in item.tags">{{tag.name}}{{tag == item.tags[item.tags.length - 1] ? '' : ', ' }} </span>
            </template>
            <template v-slot:header.name>
              Блюдо<br>
            </template>
            <template v-slot:item.category.name="{ item }">
              {{ item.category.name }} {{ item.category.parent ? '- ' + item.category.parent : '' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                          small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item @click="$router.push({ name: 'product-edit', params: { id: item.id } })">
                    <v-list-item-title>Редактировать</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="submitDialog = true; submitItem = item">
                    <v-list-item-title>Удалить</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <constructor-modifiers-table></constructor-modifiers-table>
        </v-tab-item>
        <v-tab-item>
          <modifiers-group-modal v-model="category" :is_constructor="true"></modifiers-group-modal>
          <modifiers-group-table v-model="category.modifiers_group" :disabled="true" :loading="loading"></modifiers-group-table>
        </v-tab-item>
      </v-tabs-items>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import ProductService from './../../api/ProductService'
  import CategoryService from './../../api/CategoryService'
  import TagService from './../../api/TagService'
  import ConstructorModifiersTable from "../../components/ConstructorModifiersTable";
  import ModifiersGroupModal from "../../components/ModifiersGroupModal";
  import ModifiersGroupTable from "../../components/ModifiersGroupTable";

  export default {
    name: 'ProductIndex',
    components: {ConstructorModifiersTable, ModifiersGroupModal, ModifiersGroupTable},
    data: () => ({
      dialog: false,
      tab: 0,
      selected: [],
      constructorEnabled: false,
      submitDialog: false,
      submitItem: null,
      filters: {
        tag: {
          value: [],
          tempValue: [],
          modal: false,
        },
      },
      overlay: false,
      loading: true,
      tags: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Блюд на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [-1]
      },
      headers: [
        {
          text: 'Блюдо',
          value: 'name',
        },
        {
          text: 'Категория',
          value: 'category.name',
          sortable:false
        },
        {
          text: 'Теги',
          value: 'tag',
          sortable: false
        },
        {
          text: 'Цена',
          value: 'price',
        },
        {
          text: 'Кол-во заказов',
          value: 'order_items_count',
        },
        { value: 'actions', sortable: false, width: "5%"},
      ],
      products: [],
      pizzas: [],
      category: {},
    }),
    mounted() {
      TagService.list().then(response => {
        this.tags = response.data
      });
      ProductService.list({pizzas: true}).then(response => {
        this.pizzas = response.data
      })

      ProductService.checkConstructor().then(response => {
          this.constructorEnabled = response.data
      })

      CategoryService.get(8)
        .then(response => {
          this.category = response.data;
        });


    },
    watch: {
      constructorEnabled: function (){
          ProductService.toggleCheckConstructor().then(response => {

          })
      },
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      "filters.tag.value": {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    methods: {
      getItemClass(item){
        if(item.hide == 1){
          return 'hidden-product'
        }
      },
      submitDelete(item = null){
        if(item){
          this.removeFromConstructor(item)
        } else {
          this.massDelete()
        }
      },
      massDelete(){
        let params = {
          ids: this.collectSelectedId()
        };

        ProductService.removeFromConstructorMass(params).then(response => {
          this.getDataFromApi()
        })
      },
      isExist(item){
        if(this.products.find(product => product.id === item.id)){
          return true
        }
        return false
      },
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      addProductsToConstructor(){
        let ids = [];
        this.pizzas.forEach(function (pizza) {
          if(pizza.selected){
            ids.push(pizza.id)
          }
        })

        ProductService.addToConstructor(ids).then(response => {
          this.getDataFromApi()
        })
      },
      removeFromConstructor(item){
        let formData = new FormData();
        this.loading = true
        formData.append('constructor', 0);

        ProductService.update(item.id, formData).then(response => {
          this.getDataFromApi()
        })
      },
      setTagFilter(e) {
        this.filters.tag.value = this.filters.tag.tempValue
        this.filters.tag.modal = false;
        this.overlay = false;
      },
      getDataFromApi() {
        this.loading = true
        this.selected = [];
        let params = {
          tags: this.filters.tag.value,
        }
        ProductService.listConstructor(params)
          .then(response => {
            this.selected = []
            this.products = response.data
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss">
  .v-input--switch{
    &.v-input--selection-controls{
      margin-top: 0;
    }
    .v-label{
      transform: none!important;
    }
    .v-input--switch__track{
      color: #E0E8F0!important;
      &.primary--text{
        color: #E0E8F0!important;
      }
    }
    .v-input--switch__thumb{
      &.primary--text{
        color: #2196F3 !important;
      }

    }
  }
  table{
    tr{
      &.hidden-product{
        background-color: #FFEEEC;
      }
    }
  }

  ul{
    list-style-type: none;
    padding-left: 0!important;
    li{
      list-style-type: none;
      display: grid;
      grid-template-columns: 40px 1fr;
      margin-bottom: 8px;
      .v-simple-checkbox{
        text-align: center;
      }
      &.selected{
        background-color: #EEF8FF;
      }
      .name{
        line-height: 40px;
        color: #666;
        font-weight: 500;
        padding-left: 8px;
        font-size: 14px;
      }
    }
  }

</style>


<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
